import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpRequest, HttpParams, HttpHeaders, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService } from '../auth';
import { Globals } from '../globals';
import { Cookie } from 'ng2-cookies';
import { Observable } from 'rxjs';

@Injectable()
export class DebriefingSAPOService implements OnInit {

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    ngOnInit() : void {
        this.authService.isTokenValid();
    }
    /*
    * Upload file to be reviewed
    * @param file the file to be uploaded
    */
    uploadFile(file: File, edition: String) : Observable<HttpEvent<{}>> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/debriefingsapo/' + edition;
        let requestHeaders = new HttpHeaders()
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
        let excelfile: FormData = new FormData();
        excelfile.append('excelfile', file);

        const req = new HttpRequest('POST', url, excelfile, {
          headers: requestHeaders,
          reportProgress: false,
          responseType: 'json'
        });

        return this.http.request(req);
    }
    
    /*
    * Download the return excel file as a stream
    * @param uuid ExportData identifier 
    * @param type the ExportData type
    */
    getExcelStream(uuid, type) {
        this.authService.isTokenValid();
      
      const url = this.authService.getResourceURL() + '/api/v1/import/showSapoExcel/' + uuid;
      let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'blob'}) 
    }  

    /**
     * Download the debrief template.
     */
    getDebriefTemplate() : Observable<Blob> {
        this.authService.isTokenValid();

        const url = this.authService.getResourceURL() + '/api/v1/import/debrief-template';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        
        return this.http.get(url, { headers: requestHeaders, responseType: 'blob' });
    }    
}